export default function AddVendorProductDialogController(
  $scope,
  $rootScope,
  ssDialogService,
  loaderService,
  alerts,
  emDataService,
  vmSharedModelService
) {
  const vm = this;

  vm.newProduct = { ...vm.product };
  vm.handleCloseDialog = handleCloseDialog;
  vm.handleSubmit = _handleSubmit;

  _activate();


  /** *****************************************
   * Event Handlers
   */

  function handleCloseDialog() {
    _closeDialog();
  }

  function _handleSubmit() {
    if ($scope.emAddVendorProductForm.$invalid) {
      return Promise.resolve();
    }

    if ((vm.newProduct.name === null) || (vm.newProduct.name === '')) {
      return Promise.resolve();
    }

    const isNew = vm.newProduct.productId < 0;

    if (!isNew && angular.equals(vm.product, vm.newProduct)) {
      // No need to save
      return _closeDialog(); // or return Promise.resolve();
    }
    loaderService.showViewLoader = true;
    return vmSharedModelService.saveProduct(vm.newProduct)
      .then((savedProduct) => {
        angular.extend(vm.newProduct, savedProduct);
        angular.extend(vm.product, vm.newProduct);
        if (isNew && vm.addCallback) {
          vm.addCallback(vm.product);
        }
        $rootScope.$broadcast('refreshFunctionVendor', {
          vendorId: vm.newProduct.vendorId,
          productId: vm.newProduct.productId,
        });
        return _closeDialog().then(() => {
          alerts.success('The product has been saved successfully.');
        });
      })
      .catch(() => {
        alerts.error('An error occurred while saving the Product.');
      })
      .finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  /** *****************************************
   * Private Functions
   */

  function _activate() {
    const isNew = vm.product.productId < 0;

    if (isNew) {
      vm.title = 'Add Product';
    } else {
      vm.title = 'Edit Product';
    }
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.enterpriseModeling.editProductDialog);
  }
}

AddVendorProductDialogController.$inject = [
  '$scope',
  '$rootScope',
  'ssDialogService',
  'loaderService',
  'alerts',
  'emDataService',
  'vmSharedModelService'
];
